module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centered-container",
    attrs: {
      "id": "login"
    }
  }, [_c('md-content', {
    staticClass: "md-elevation-3"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl()
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('md-field', [_c('label', [_vm._v("Usuario")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "autofocus": ""
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1), _vm._v(" "), _c('md-field', {
    attrs: {
      "md-has-password": ""
    }
  }, [_c('label', [_vm._v("Contraseña")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "actions md-layout md-alignment-center"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#loading-modal-modal"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Iniciar Sesión")])], 1)]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": _vm.modalName,
      "cclass": "transparent"
    }
  }, [_c('loading-modal', {
    attrs: {
      "info": _vm.modalInfo
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50d96a13","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/Login.vue
// module id = 1701
// module chunks = 6